import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmPopupComponent } from './confirm-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [ConfirmPopupComponent],
  imports: [CommonModule, MaterialModule],
  exports: [ConfirmPopupComponent],
})
export class ConfirmPopupModule {}
